var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBetCityLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 34,
    viewBox: "0 0 264 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.3678 0.531252H75.7731L74.5448 8.12054H55.6591L54.9681 12.4464H66.2535L64.9484 20.2634H53.7398L52.9721 25.4241H73.7003L72.3952 33.4688H42.0706L47.3678 0.531252Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2062 8.65179H78.3066L79.6117 0.531252H112.93L111.549 8.65179H99.649L95.6569 33.4688H86.2141L90.2062 8.65179Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M113.621 18.5938C113.237 7.89286 120.761 0 131.048 0C143.025 0 146.556 7.89286 146.94 11.6875H137.267C136.806 10.7768 135.117 8.42411 131.355 8.42411C126.058 8.42411 123.064 12.9018 123.295 18.1384C123.448 22.3884 125.828 25.5759 129.974 25.5759C133.812 25.5759 135.501 23.375 136.039 22.5402H145.635C145.021 25.5 141.105 34 130.281 34C120.377 34 113.928 27.7009 113.621 18.5938Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M153.773 0.531252H163.292L160.145 20.3393L178.032 0.531252H187.552L182.255 33.4688H172.735L175.883 13.7366L157.995 33.4688H148.476L153.773 0.531252Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M202.753 8.65179H190.853L192.158 0.531252H225.477L224.172 8.65179H212.272L208.28 33.4688H198.837L202.753 8.65179Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M230.16 0.531252H239.68L236.455 20.4152L254.343 0.607145H263.863L258.565 33.5446H249.046L252.193 13.8125L234.306 33.5446H224.786L230.16 0.531252Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5648 12.75H17.12L17.8109 8.72768H37.8482L39.1533 0.607141H9.51963L7.60035 12.75H1.22834L0 20.1875H6.37201L4.22242 33.4687H23.8758C33.0884 33.4687 39.2301 29.5223 38.923 21.4777C38.7695 15.8616 34.0096 12.75 25.5648 12.75ZM24.7203 25.2723H15.0472L15.8916 20.1875H25.8719C27.8679 20.1875 28.866 20.8705 28.866 22.1607C29.0195 24.2098 27.3305 25.2723 24.7203 25.2723Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetCityLogo);
export default __webpack_public_path__ + "static/media/bet-city-logo.f0270530eabd4f7352dae2ab96046f13.svg";
export { ForwardRef as ReactComponent };